import { useTranslation } from 'react-i18next'
import { shallowEqual, useSelector } from 'react-redux'
import { Button } from '@mui/material'

import { format } from 'date-fns'
import { useWalletsTable, useWalletsActions } from '@/views/wallets/hooks'
import { walletsSelector } from '@/state/wallets/slices/index.slices'

import { dateTimeTableFormat } from '@/constants/date'
import { WalletLibraryColumnProps } from '@/state/wallets/models'
import { TableGenericComponent } from '@/views/components'

import { WalletsTableRowComponent } from './'

type Props = {
  handleChangeLimit: (newLimit: number) => void
  handleChangePage: (newPage: number) => void
}

export const WalletsGeneralTableComponent = ({
  handleChangePage,
  handleChangeLimit,
}: Props) => {
  const { t } = useTranslation()

  const {
    isLoading,
    sortedRows,
    createSortHandler,
    order,
    orderBy,
    headCells,
    pagination,
    getXlsFormattedRow,
  } = useWalletsTable()

  const { getAllWallets } = useWalletsActions()

  const { filters } = useSelector(walletsSelector, shallowEqual)

  const body = sortedRows.map((row: WalletLibraryColumnProps) => {
    return <WalletsTableRowComponent key={row.id} row={row} />
  })

  const fileName = `wallets-${format(new Date(), dateTimeTableFormat)}`

  const xlsxButton = (
    <Button
      onClick={() =>
        getAllWallets(
          {
            ...filters,
            page: 1,
            limit: 999999,
            xlsx: true,
          },
          headCells,
          fileName,
          getXlsFormattedRow,
        )
      }
      variant="contained"
    >
      {t('labels.downloadAsXLS')}
    </Button>
  )

  return (
    <TableGenericComponent<WalletLibraryColumnProps>
      order={order}
      orderBy={orderBy}
      headCells={headCells}
      rowLength={sortedRows.length}
      pagination={pagination}
      isLoading={isLoading}
      body={body}
      hasAction={true}
      leftContent={xlsxButton}
      createSortHandler={createSortHandler}
      handleChangePage={handleChangePage}
      handleChangeLimit={handleChangeLimit}
    />
  )
}
